__webpack_require__.p = "https://product-search.core-artifacts.com/static/";